import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';

import ModalComponent from 'components/ModalComponent';

import './FeeChangeConfirmartionModal.scss';
import registeredComponent from '../../utils/registeredComponent';
import { modals } from '../../ducks';

const FeeChangeConfirmationModal = props => {
  const onConfirm = () => {
    const {
      dispatch, formAction, formData, updateInitialValues
    } = props;
    const token = $('meta[name="csrf-token"]').attr('content');

    fetch(formAction, {
      method: 'PATCH',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-CSRF-Token': token
      },
      body: formData
    })
      .then(response => response.json())
      .then(response => {
        dispatch(modals.actions.hide());

        if (response.error) {
          Utility.errorMessage(response.error);
        } else {
          Utility.successMessage(response.message);
          updateInitialValues();
        }
      });
  };

  return (
    <ModalComponent
      title='Confirm Changes'
      className='convenience-fee-wrapper'
      buttons={[
        <Button variant='primary' onClick={onConfirm}>Confirm</Button>
      ]}
    >
      <div>There is a change in the Fee Rate or Fee amount.</div>
      <br />
      <div>Email notifications will be sent to parents who have opted for autopay.</div>
      <br />
      <a href='/setup/billing_snippets' target='_blank'>
        View the &quot;Rate Change&quot; email template
        &nbsp;
        <FontAwesome name='external-link' />
      </a>
    </ModalComponent>
  );
};

FeeChangeConfirmationModal.propTypes = {
  formAction: PropTypes.string.isRequired,
  formData: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  updateInitialValues: PropTypes.func.isRequired
};

export default connect()(registeredComponent('FeeChangeConfirmationModal')(FeeChangeConfirmationModal));
